import { useIntl } from "react-intl";
import { Col, Row } from "reactstrap";
import Layout from "../../components/Layout/Layout";
import useDynamicComponent from "../../components/dynamics/useDynamicComponent";
import PageTitle from "../../components/Layout/PageTitle";

export default function EquipmentCreate() {
  const MainContent = useDynamicComponent("EquipmentCreate");
  const intl = useIntl();

  return (
    <Layout>
      <div className="pageContainer">
        <div className="pageHeader">
          <Row style={{ margin: "0px", padding: "0px" }}>
            <Col style={{ margin: "0px", padding: "0px" }}>
              <PageTitle
                title={`${intl.formatMessage({
                  id: "Screens.EquipmentCreate.Title",
                })}:`}
                allowGoBack={true}
              />
            </Col>
          </Row>
        </div>

        <div className="pageBody">{MainContent}</div>
      </div>
    </Layout>
  );
}
